export default "__VITE_ASSET__CcXWCIAW__"